import { Separator, Stack } from "@chakra-ui/react";
import { Spreadsheet } from "./Spreadsheet";
import { ViewComments } from "../../BottomBar/ViewComments";

export const SpreadsheetView: React.FC = () => (
  <Stack overflow="hidden" flexGrow={1} separator={<Separator />} gap={0}>
    <Spreadsheet />
    <ViewComments />
  </Stack>
);
